import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
import consumer from "../../assets/javascript/channels/consumer"

export default class extends Controller {
  static targets = ["spinner", "button", "customExportButton", "customSpinner"]

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "FileDownloadChannel", room: "main" },
      {
        received: (data) => {
          if (data.message && data.message.filename) {
            window.location.href = `/download_file?filename=${data.message.filename}`
            // Ocultar todos los spinners y restaurar botones
            this.spinnerTargets.forEach(spinner => {
              spinner.style.display = "none"
            })
            this.buttonTargets.forEach(button => {
              button.classList.add('option-row')
              button.classList.remove('option-row-disabled')
            })

            // Manejar spinners personalizados
            this.customSpinnerTargets.forEach(spinner => {
              spinner.classList.add('hidden')
            })
            this.customExportButtonTargets.forEach(button => {
              button.classList.add('option-row')
              button.classList.remove('option-row-disabled')
            })
          }
        }
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  async mass_export() {
    this.spinnerTargets.forEach(spinner => {
      spinner.style.display = "block"
    })
    this.buttonTargets.forEach(button => {
      button.classList.remove('option-row')
      button.classList.add('option-row-disabled')
    })

    const exportPath = this.buttonTarget.dataset.massExportPath

    console.log(exportPath)

    try {
      let response = await get(exportPath, { responseKind: 'turbo-stream' })
      if (!response.ok) throw new Error('Network response was not ok')
    } catch (error) {
      console.error('Error en la exportación:', error)
      this.spinnerTargets.forEach(spinner => {
        spinner.style.display = "none"
      })
      this.buttonTargets.forEach(button => {
        button.classList.add('option-row')
        button.classList.remove('option-row-disabled')
      })
    }
  }

  async customExport(event) {
    const button = event.currentTarget
    const spinner = button.querySelector('[data-model_bulk_actions-target="customSpinner"]')
    const exportPath = button.dataset.exportPath

    spinner.classList.remove('hidden')
    button.classList.remove('option-row')
    button.classList.add('option-row-disabled')

    try {
      let response = await get(exportPath, { responseKind: 'turbo-stream' })
      if (!response.ok) throw new Error('Network response was not ok')
    } catch (error) {
      console.error('Error en la exportación:', error)
      spinner.classList.add('hidden')
      button.classList.add('option-row')
      button.classList.remove('option-row-disabled')
    }
  }
}
